export default {
  title: "Let's Grow Our Community Together.",
  subTitle:
    'Share Revuud and cultivate connections. If you know of colleagues or friends who would enhance their professional presence by creating a profile or exploring Talent, spread the word!',
};
